import { BotIcon, SparklesIcon, WorkflowIcon } from 'lucide-react';

import type { LibraryItemKind } from '@/lib/api/generated/model';
import { cn } from '@/lib/utils';

const ICON = {
  workflow: WorkflowIcon,
  agent: BotIcon,
  skill: SparklesIcon,
} as const;

/** The kind, as a line-art icon on a raised square: the row's leading mark. */
export function KindMonogram({
  kind,
  size = 'md',
}: {
  kind: LibraryItemKind;
  size?: 'sm' | 'md';
}) {
  const Icon = ICON[kind];
  return (
    <span
      aria-hidden="true"
      className={cn(
        // `muted`/`border`, not the provisional light-only surfaces: those have no
        // dark value and rendered as white boxes on the dark theme.
        'bg-muted text-foreground border-border flex shrink-0 items-center justify-center rounded-md border',
        size === 'md' ? 'size-10' : 'size-7',
      )}
    >
      <Icon
        className={size === 'md' ? 'size-5' : 'size-3.5'}
        strokeWidth={1.75}
      />
    </span>
  );
}
